import { I18n } from 'react-redux-i18n'

const getActions = ({ rawActions, actionType, containerType, fromActionType, fromAction }) => {
  let actionsOptions = []

  switch (actionType) {
    case 'botAction':
      if (fromActionType) {
        switch (fromActionType) {
          case 'customerAction':
            rawActions.customerAction[fromAction].forEach(action => {
              actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
            })
            break
          case 'operatorAction':
            rawActions.operatorAction[fromAction].forEach(action => {
              actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
            })
            break
          case 'transactionalAction':
            rawActions.transactionalAction[fromAction].forEach(action => {
              actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
            })
            break
          case 'backendAction':
            rawActions.backendAction[fromAction].forEach(action => {
              actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
            })
            break
          default:
            break
        }
      } else {
        switch (containerType) {
          case 'onNewProcess':
            rawActions.onNew.forEach(action => {
              actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
            })
            break
          case 'onLeaveProcess':
            rawActions.onLeave.forEach(action => {
              actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
            })
            break
          default:
            break
        }
      }
      break
    case 'customerAction':
      Object.keys(rawActions.customerAction).forEach(action => {
        if (['HELLO', 'BYE', 'THANKS'].includes(action)) return
        actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
      })
      break
    case 'operatorAction':
      Object.keys(rawActions.operatorAction).forEach(action => {
        if (['processPositiveSentiment', 'processNegativeSentiment'].includes(action)) return
        actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
      })
      break
    case 'transactionalAction':
      Object.keys(rawActions.transactionalAction).forEach(action => {
        actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
      })
      break
    case 'backendAction':
      Object.keys(rawActions.backendAction).forEach(action => {
        actionsOptions.push({ value: action, label: I18n.t(`smartchat_actions_${action}`) })
      })
      break
    default:

  }

  return actionsOptions
}

export default getActions
